import { Button, Stack } from "@mui/material";
import { useContext } from "react";
import { ConstantContext } from "components/context/ConstantProvider";
import { Form, FormContext } from "components/shared/Form";
import ListSelectField from "components/ui/atoms/formFields/ListSelectField";
import UserField from "components/ui/atoms/formFields/UserField";
import { Box } from "@mui/system";

const asArray = (obj) => {
  return Array.isArray(obj) ? obj : obj ? [obj] : [];
};

const prepareInitialValues = (object) => ({
  user: asArray(object?.user),
  process_code: asArray(object?.process_code),
  status: asArray(object?.status),
});

const AsyncProcessesFilterFormFields = ({}) => {
  const { asyncProcessesStatus, asyncProcessesList } =
    useContext(ConstantContext);

  const { onSubmit } = useContext(FormContext);

  return (
    <Stack spacing={1}>
      <UserField name="user" label="User" multiple />
      <ListSelectField
        options={asyncProcessesList.map((x) => [x.value, x.label])}
        multiple
        name="process_code"
        label="Process name"
      />
      <ListSelectField
        options={asyncProcessesStatus.map((x) => [x.code, x.label])}
        multiple
        name="status"
        label="Status"
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={onSubmit}>
          Apply
        </Button>
      </Box>
    </Stack>
  );
};

const AsyncProcessesFilterForm = (props) => {
  return (
    <Form prepareInitialValues={prepareInitialValues} {...props}>
      <AsyncProcessesFilterFormFields />
    </Form>
  );
};

export default AsyncProcessesFilterForm;
